// extracted by mini-css-extract-plugin
module.exports = {"tabs__content":"styles_tabs__content__kFSeC","pulse":"styles_pulse__YPZvx","jump":"styles_jump__Hx2aR","wiggle":"styles_wiggle__mqepM"};